import { Button, Grid, Icon, TextField } from "@mui/material";
import * as React from "react";
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';

export default function ArrayFormInput(props) {
  
  const { fields } = props
  const { setFields } = props
  const { disabled } = props

  const handleAddField = () => {
      setFields(
          fields.concat([""]),
      );
  };

  const handleRemoveField = (idx) => () => {
      setFields(
          fields.filter((r, fidx) => idx !== fidx),
      );
  };

  const handleFieldChange = (idx) => (evt) => {
      const newFields = fields.map((field, fidx) => {
        if (idx !== fidx) return field;
        return evt.target.value;
      });
      setFields(newFields);
  }
  
  React.useEffect(() => {
    
  }, []);

  return (
    <Grid container spacing={2}>
      {fields.map((field, idx) => (
      <Grid key={idx} item container spacing={2} className="field">
          <Grid item sx={{width: "80%"}}>
            <TextField
            disabled={disabled}
            fullWidth multiline
            type="text"
            value={field}
            onChange={handleFieldChange(idx)}
            />
          </Grid>
          <Grid item>
            <Button disabled={disabled} variant="outlined" color="primary" onClick={handleRemoveField(idx)} sx={{height:"55px"}}>
              <RemoveCircleIcon/>
            </Button>
          </Grid>
      </Grid>
      ))}
      <Grid item>
        <Button disabled={disabled} variant="outlined" color="primary" onClick={handleAddField} className="small">
        Add A Field
        </Button>
      </Grid>
    </Grid>
  );
}
